import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import CloseIcon from "@mui/icons-material/Close";
import Styles from "./Navbar.module.css";
import { ReactComponent as Gna } from "../../assets/images/logo.svg.svg";
import { ReactComponent as Notification } from "../../assets/images/mdi_bell-notification.svg";
import { useSelector } from "react-redux";
import NavProfile from "./NavProfile";

const navList = {
  CONSUMER: [
    { name: "Home", url: "dashboard" },
    { name: "Bilateral Ledger", url: "bilateral" },
    { name: "Auction", url: "auction" },
    { name: "Search Listing", url: "search_listing" },
    { name: "Landing Cost Calculator", url: "lcc" },
    { name: "Past Listing", url: "past_listing_con_gen" },
  ],
  GENERATOR: [
    { name: "Home", url: "dashboard" },
    { name: "Ledger", url: "bilateral" },
    { name: "Auction", url: "auction" },
    { name: "Search Listing", url: "search_listing" },
    { name: "Landing Cost Calculator", url: "lcc" },
    { name: "Past Listing", url: "past_listing_con_gen" },
  ],
  COMPANY_ADMIN: [],
};

const MobileNavbar = ({ open, handleClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole
  );
  const token = useSelector((state) => state?.persistedReducer?.token);

  const handleRoute = (url) => {
    navigate(`/${url}`);
    handleClose();
  };

  const isActiveRoute = (url) => {
    return location.pathname === `/${url}`;
  };

  return (
    <Drawer anchor="left" open={open} onClose={handleClose}>
      <div className={Styles.mobileNavContainer}>
        <div className={Styles.navHeaderContainer}>
          <Gna />
          <div onClick={handleClose} className={Styles.closeButton}>
            <CloseIcon />
          </div>
        </div>

        <div className={Styles.mobileNavItems}>
          {navList[role]?.map((item) => (
            <div
              key={item.url}
              className={`${Styles.mobileNavItem} ${
                isActiveRoute(item.url) ? Styles.activeMobileNavItem : ""
              }`}
              onClick={() => handleRoute(item.url)}
            >
              {item.name}
            </div>
          ))}
        </div>

        {token && (
          <div className={Styles.mobileNavFooter}>
            <Notification />
            <NavProfile />
          </div>
        )}
      </div>
    </Drawer>
  );
};

export default MobileNavbar;
